import React from 'react';


const PlayerCardEpidemic = () =>
  <span>
    <span className="e">E</span>
    &nbsp;
    Epidemic
  </span>;

export default PlayerCardEpidemic;



/** WEBPACK FOOTER **
 ** ./src/components/teamPanel/PlayerCardEpidemic.js
 **/